// let API_URL_ = "https://flintinfotech.com/voterdatamgmt/";
let API_URL_ = "https://vikrantpatiloffice.in:8443/vikrantpatilvmsdev/";

export const LOCAL_UI_DOMAIN = "http://localhost:3000";
export const LOCAL_UI_NGINX_DOMAIN = "http://localhost:9192";
export const DEV_UI_DOMAIN = "http://localhost:9192";
export const QA_UI_DOMAIN = "https://flintinfotech-dev.in:8443";
export const PROD_UI_DOMAIN = "https://vikrantpatiloffice.in";
export const PROD_VOTERSYNC_UI_DOMAIN = "https://votersync.in";

//export const LOCAL_BE_DOMAIN = "https://flintinfotech.com/voterdatamgmt/"
// export const LOCAL_BE_DOMAIN = "https://vikrantpatiloffice.in:8443/voterdatamgmt/"
export const LOCAL_BE_DOMAIN = "https://vikrantpatiloffice.in:8443/voterdatamgmtdev/";
export const LOCAL_BE_NGINX_DOMAIN = "http://localhost:8082/voterdatamgmt/";
export const DEV_BE_DOMAIN = "http://localhost:8082/voterdatamgmt/";
export const QA_BE_DOMAIN = "https://flintinfotech.com/voterdatamgmt/";
// export const PROD_BE_DOMAIN = "https://vikrantpatiloffice.in:8443/voterdatamgmt/"
export const PROD_BE_DOMAIN =
  "https://vikrantpatiloffice.in:8443/vikrantpatilvms/";
export const PROD_VOTERSYNC_BE_DOMAIN =
  "https://vikrantpatiloffice.in:8443/voterdatamgmt/";

export const CLR_SUCCESS = "#10B981";
export const CLR_WARNING = "#EF9138";
export const CLR_ERROR = "#DC2626";
export const CLR_INFO = "#2563EB";
export const CLR_CANCEL = "#0000004a";

const currentHref = window.location.href;

if (currentHref.includes(LOCAL_UI_DOMAIN)) {
  /** Local */
  API_URL_ = LOCAL_BE_DOMAIN;
  // API_URL_ = QA_BE_DOMAIN;
}
if (currentHref.includes(LOCAL_UI_NGINX_DOMAIN)) {
  /**  Local - ngnix -  */
  API_URL_ = LOCAL_BE_NGINX_DOMAIN;
}
if (currentHref.includes(DEV_UI_DOMAIN)) {
  /**  Dev */
  API_URL_ = DEV_BE_DOMAIN;
}
if (currentHref.includes(QA_UI_DOMAIN)) {
  /**  QA */
  // API_URL_ = QA_BE_DOMAIN
  API_URL_ = PROD_BE_DOMAIN;
}
if (currentHref.includes(PROD_UI_DOMAIN)) {
  /**  Prod */
  API_URL_ = PROD_BE_DOMAIN;
}
if (currentHref.includes(PROD_VOTERSYNC_UI_DOMAIN)) {
  /**  Prod Votersync */
  API_URL_ = PROD_VOTERSYNC_BE_DOMAIN;
}

let IS_GENERIC_THEME_APP_ = false;

if (!["vikrantpatil"].some((str) => currentHref.includes(str))) {
  IS_GENERIC_THEME_APP_ = true;
}

export const IS_GENERIC_THEME_APP = IS_GENERIC_THEME_APP_;
// export const IS_GENERIC_THEME_APP = true

export const API_URL = API_URL_;
// export const API_URLS = API_URLS_;
export const AUTH_ENDPOINT = "auth/login";
export const AUTH_GETCLIENTBYID = "user/getClientById"
export const UPLOAD_DATA = "file/vdExcelFile";
export const SHOW_VOTER_VOTER_DIFFERENCE = "file/showVoterDataDifference";
export const PROCESS_VOTER_DIFFERENCE = "file/processVoterDataDifference";
export const GET_VOTER_DATA = "voter/getVoterData";
export const GET_VOTER_DATA_BY_ID = "voter/getVoterDataById";
export const UPDATE_VOTER_DATA = "voter/saveVoter";
export const UPDATE_VOTER_DATA_BATCHED = "voter/updateVoterData";
export const UPDATE_WORK_DONE_BATCHED = "voter/saveVotersWorkDetails";
export const VERIFY_SUPPORTER = "voter/verifySupporter";
export const GET_VOTERS_BY_CATEGORY = "dashboard/getVotersByCategory";

export const GET_ALL_VOTER_CALL = "calls/getAllVoterCallsByFilter";
export const SAVE_VOTER_CALL = "calls/saveVoterCallsEntity";
export const GET_VOTER_CALL_BY_ID = "calls/getVoterCallsEntityById";

export const GET_VOTER_DASHBOARD_WORK_DONE = "voter/getVoterWorkData";
export const GET_VOTER_DASHBOARD_WORK_DONE_EXPORT = "voter/getVoterWorkExcel";
export const GET_NON_VOTER_DASHBOARD_WORK_DONE = "nonVoter/getNonVoterWorkData";
export const GET_NON_VOTER_DASHBOARD_WORK_DONE_EXPORT =
  "nonVoter/getNonVoterWorkDataExcel";

export const GET_DASHBOARD_VOTER_COUNTS = "dashboard/getVoterDashboardCounts";
export const GET_DASHBOARD_NON_VOTER_COUNTS =
  "dashboard/getNonVoterDashboardCounts";

export const DROPDOWN_DATA = "staticData/getStaticDataDD";
export const DOWNLOAD_TEMPLATE = "file/exportExcel";
export const REPORTS = "report/genReport";
export const REPORTS_EXPORT = "report/genReportCsv";

export const UPDATE_DETAILS = "user/updateFirstNameLastName";

export const ADD_NON_VOTER_DATA = "nonVoter/addNonVoterData";
export const EDIT_NON_VOTER_DATA = "nonVoter/editNonVoter";
export const GET_NON_VOTER_DATA = "nonVoter/getNonVoterData";
export const GET_NON_VOTER_DATA_BY_ID = "nonVoter/getNonVoterDataById";
export const CONVERT_TO_VOTER = "nonVoter/addNonVoterDataToVoter";

export const GET_USER_DATA = "user/getAllUsers";
export const ADD_USER_DATA = "user/addUser";
export const EDIT_USER_DATA = "user/updateUser";
export const DELETE_USER = "user/deleteUserByUserId";

export const GET_BIRTHDAYS_VOTER = "birthday/getTodayBirthday/Voter";
export const GET_BIRTHDAYS_NON_VOTER = "birthday/getTodayBirthday/NonVoter";
export const SAVE_BIRTHDAY_WISH = "birthday/saveBirthday";

export const GET_APPMNT = "appointment/getAppointmentBasedOnFilter";
export const GET_APPMNT_BY_ID = "appointment/getAppointmentByAppointmentId";
export const ADD_APPOINTMENT = "appointment/saveAppointment";
export const GET_SELECTED_USER_APPOINTMENTS_BY_DATE =
  "appointment/getAppointmentByUserAndDate";
export const GET_STATIC_DATA = "/staticData/getStaticDataDD";

export const GET_WORK_DONE_BY_VOTER_ID = "voter/getWorkDetailsByVoterDataId";

export const GET_WORK_DONE_BY_FILTERS_VOTER = "voter/getWorkDoneFiltersVoter";
export const GET_WORK_DONE_BY_FILTERS_NON_VOTER =
  "voter/getWorkDoneFiltersNonvoter";

export const GET_WORK_DETAILS_BY_NON_VOTER_ID =
  "nonVoter/getNonVoterWorkDetailsByVoterDataId";
export const ADD_WORK_DETAILS_FOR_NON_VOTER = "nonVoter/addNonVoterData";
export const UPDATE_WORK_DETAILS_BY_NON_VOTER_ID = "nonVoter/editNonVoter";

export const UPDATE_VOTER_WORK_ROW_BY_ID = "voter/updateWorkDtls";
export const UPDATE_NON_VOTER_WORK_ROW_BY_ID = "nonVoter/updateWorkDtls";

export const GET_ELECTION_POLLS = "electionResults/getElectionResultData";
export const UPDATE_ELECTION_POLL = "electionResults/saveElectionResults";
export const GET_BOOTH_LIST = "electionResults/getListOfBooths";

export const GET_VOTER_AUDIT_DATA = "audit/getVoterAuditData";
export const GET_VOTER_AUDIT_DATA_BY_ID = "audit/getAuditDataByVoterDataId";

export const GET_VOTER_CALLS_DASHBOARD_COUNT_BY_STATUS =
  "dashboard/getVoterCallsDashboardCountByStatus";
export const GET_VOTER_CALLS_DASHBOARD_COUNT_BY_USER =
  "dashboard/getVoterCallsDashboardCountByUser";

export const SEND_GENERAL_MESSAGES = "whatsApp/sendGeneralMsg";

export const GET_ELECTION_DATA = "election-data/get";
export const SAVE_OR_UPDATE_DATA = "election-data/saveOrUpdate"
export const PRINT_ELECTION_DATA_FOR_VOTERS = "election-data/printElectionDataForVoters"

export const MobileNumberRegexPattern = /^\d{10}$/;
export const OnlyTextRegexPattern = /^[a-zA-Z\s]*$/;
export const EmailRegexPattern =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const API_MESSAGE_LOADING = "Loading...";
export const API_MESSAGE_ERROR = "Some error occured";

export const API_STATUS_LOADING = "loading";
export const API_STATUS_SUCCESS = "success";
export const API_STATUS_ERROR = "error";

export const API_STATUS_IMPORT_SHEET_ERRORS =
  "Please remove any errors in data (Check the data tabs for more info)";

export const API_STATUS_TYPE_LOADING = "info";
export const API_STATUS_TYPE_SUCCESS = "success";
export const API_STATUS_TYPE_ERROR = "error";

export const ASK_FNAME_LNAME_EDIT = "user_details_edit";

export const markedNotation = "(M)";
export const MAX_RECORDS = 9999999;

export const dashboardTabName = "Homepage";
export const votersTabName = "Voters Dashboard";
export const votersCallTabName = "Voters Call Dashboard";
export const nonVotersTabName = "Non Voters Dashboard";
export const reportsTabName = "Reports";
export const supportersTabName = "Supporters";
export const usersTabName = "Users";
export const birthdaysTabName = "Birthdays";
export const worksTabName = "Works";
export const electionPollsTabName = "Election Polls";
export const appointmentsTabName = "Appointments";
export const auditsTabName = "Audits";

export const dashboardRoute = "/dashboard";
export const votersRoute = "/dashboard/voters";
export const votersCallRoute = "/dashboard/voters-call";
export const nonVotersRoute = "/dashboard/non-voters";
export const reportsRoute = "/dashboard/reports";
export const supportersRoute = "/dashboard/supporters";
export const usersRoute = "/dashboard/users";
export const birthdaysRoute = "/dashboard/birthdays";
export const worksRoute = "/dashboard/works";
export const electionPollsRoute = "/dashboard/election-polls";
export const appointmentsRoute = "/dashboard/appointments";
export const auditsRoute = "/dashboard/audits";

export const voterRouteParam = "voters";
export const nonVoterRouteParam = "non-voters";

export const MODULE_HOMEPAGE = "HOMEPAGE";
export const MODULE_VOTER = "VOTER_DATA";
export const MODULE_VOTER_CALL = "VOTER_CALL_DATA";
export const MODULE_NON_VOTER = "NON_VOTER";
export const MODULE_REPORTS = "REPORTS";
export const MODULE_USERS = "USER_CRATION";
export const MODULE_SUPPORTER = "SUPPORTER";
export const MODULE_BIRTHDAYS = "BIRTHDAY";
export const MODULE_WORKS = "WORKS";
export const MODULE_ELECTION_POLLS = "ELECTION_POLL";
export const MODULE_APPOINTMENTS = "APPOINTMENT";
export const MODULE_AUDIT = "AUDIT";

export const ROLE_ADMIN = "ADMIN";
export const ROLE_MANAGER = "MANAGER";
export const ROLE_DATA_ENTRY = "DATA_ENTRY";
export const ROLE_SUPPORTER = "SUPPORTER";

export const TABLE_FLOW_NEW_VOTER = "new voter";
export const TABLE_FLOW_SUPPORTER = "supporter";
export const TABLE_FLOW_USER = "user";
export const TABLE_FLOW_WORK_DETAILS = "work details";
export const TABLE_ADD_WORK_DONE_BATCHED = "add work done batched";

export const VIA_VOTER_WORK_DIALOG = "via voter work dialog";
export const VIA_VOTER_AUDIT_WORK_DIALOG = "via voter audit work dialog";

export const WORK_TYPE_AADHAR = "Aadhar Card";
export const WORK_TYPE_OTHER = "OTHER";

export const TWIND_NULL_COLS_BG = "200";
export const TWIND_IMPORTED_COLS_BG = "50";
export const TWIND_SAME_COLS_BG = "300";

export const colorPalet = [
  "orange",
  "green",
  // "amber",
  "violet",
  "blue",
  "red",
  "lime",
  "slate",
];

export const FORMAT_DDMMYYYY_HYPHEN = "DD-MM-YYYY";

export const WORK_STATUS_IN_PROGRESS = "Inprogress";
export const WORK_STATUS_COMPLETED = "Completed";
export const WORK_STATUS_OPEN = "Open";

export const ELECTION_PARTY_PARAM_NAMES = [
  "bhartiyaJanataParty",
  "indianNationalCongress",
  "shivSena",
  "shivSenaUbt",
  "nationalistCongressParty",
  "nationalistCongressPartySharadchandraPawar",
  "others",
];

export const ELECTION_PARTY_PARAM_MAPPING = {
  bhartiyaJanataParty: {
    title: "Bharatiya Janata Party",
    color: "#00ab22",
  },

  indianNationalCongress: {
    title: "Indian National Congress",
    color: "#1A73EC",
  },

  shivSena: {
    title: "Shiv Sena",
    color: "#EF9138",
  },

  shivSenaUbt: {
    title: "Shiv Sena (UBT)",
    color: "#c78225",
  },

  nationalistCongressParty: {
    title: "Nationalist Congress Party",
    color: "#e47272",
  },

  nationalistCongressPartySharadchandraPawar: {
    title: "Nationalist Congress Party(Sharad Chandra Pawar)",
    color: "#0088ba",
  },

  others: {
    title: "Other",
    color: "#b5b5b5",
  },
};

export const DATE_DD_MM_YYYY_REGEX = /^\d{2}-\d{2}-\d{4}$/;
export const REDUX_FILTER_POLLS = "electionPolls";

export const STATUS_CANCELLED = "Cancelled";
export const STATUS_SCHEDULED = "Scheduled";

export const SHEET_UPDATE = "Records under update";
export const SHEET_NEW = "New records";
export const SHEET_ARCHIVE = "Records to be archived";

export const exportWorksHeaders = [
  "IdCardNo",
  "FullName",
  "MobileNo",
  "WorkType",
  "DetailsType",
  "WorkMode",
  "WorkStatus",
  "AssignTo",
  "LastUpdatedUser",
  "LastUpdatedDate",
];

export const FILTER_FIELDS_SEARCH_DELAY = 100;
